import { MapPin } from 'lucide-react';
import { z } from 'zod';
import { AddressFieldInput, AddressFieldView } from '../renderers/fields/address/address-field';
import type { AddressFieldSchema, AddressValue, FieldDefinition } from '../types';

export const AddressDefinition: FieldDefinition<
  AddressFieldSchema,
  AddressValue | null | undefined
> = {
  type: 'address',
  toolboxLabel: 'Address',
  category: 'CRM & Composite',
  description: 'A composite field for capturing a full postal address.',
  icon: MapPin,

  createDefault: (id) => ({
    id,
    type: 'address',
    name: `address_${id}`,
    label: 'Address',
    required: false,
    includeCountry: true,
  }),

  configSchema: [
    { id: 'label', type: 'text', name: 'label', label: 'Field Label', required: true },
    { id: 'name', type: 'text', name: 'name', label: 'Data Key (ID)', required: true },
    {
      id: 'includeCountry',
      type: 'checkbox',
      name: 'includeCountry',
      label: 'Include Country Field',
      required: false,
    },
    {
      id: 'required',
      type: 'checkbox',
      name: 'required',
      label: 'Required Field',
      required: false,
    },
  ],

  buildValidation: (field) => {
    const addressSchema = z.object({
      street: z.string().optional(),
      city: z.string().optional(),
      state: z.string().optional(),
      zip: z.string().optional(),
      country: z.string().optional(),
    });

    if (field.required) {
      return addressSchema.refine((val) => !!val.street && !!val.city && !!val.zip, {
        message: 'Street, City, and ZIP are required',
      });
    }

    return addressSchema.optional().nullable();
  },

  editComponent: AddressFieldInput,
  viewComponent: AddressFieldView,
};
